import classNames from 'clsx';
import format from 'date-fns/format';
import React, { memo } from 'react';

import styles from '../DataListItemRow.css';

export const Date = memo(({ date, isWide, hide }: { date?: number; isWide?: boolean; hide?: boolean }) => {
    return (
        <div
            className={classNames({
                [styles.date]: true,
                [styles.date_wide]: isWide,
                [styles.date_hide]: hide,
            })}
        >
            {!!date && format(date, 'dd.MM.yy HH:mm')}
        </div>
    );
});

Date.displayName = 'Date';
